import { Link } from 'react-router-dom';
import { useState } from 'react';

const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];

const articleLinks = [
  { name: 'Beginner Guide', path: '/superbuy-spreadsheet-beginner-guide' },
  { name: 'Complete Guide', path: '/superbuy-spreadsheet-complete-guide' },
  { name: 'Templates Guide', path: '/superbuy-spreadsheet-templates-guide' },
  { name: 'Safety Guide', path: '/superbuy-spreadsheet-safety-guide' },
  { name: 'Why Choose It', hash: '#why-choose' },
  { name: 'Comparison Guide', hash: '#comparisons' },
  { name: 'How-To Guide', hash: '#how-to' },
  { name: 'Learning Center', hash: '#learning' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setStatus('success');
      setEmail('');
      return;
    }
    setStatus('loading');
    setFormError('');
    try {
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (typeof value === 'string') params.append(key, value);
      });
      const res = await fetch('https://readdy.ai/api/form/d9adi4d86d4i8fhr8vbg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && (parsed as { code?: string })?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const msg = (parsed as { meta?: { message?: string } })?.meta?.message || (parsed as { message?: string })?.message || responseText;
        setFormError(typeof msg === 'string' ? msg : 'Something went wrong. Please try again.');
        setStatus('error');
      }
    } catch {
      setStatus('error');
      setFormError('Network error. Please try again.');
    }
  };

  return (
    <footer className="bg-secondary-50/20 border-t border-background-200/70 pt-14 md:pt-20 pb-8">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-6">
          <div className="lg:col-span-2">
            <p className="font-heading text-xl md:text-2xl font-bold text-foreground-950">Superbuy<br />Spreadsheet</p>
            <p className="mt-4 text-foreground-600 text-sm max-w-sm">Your comprehensive resource for mastering spreadsheet-based shopping. Guides, templates, and expert tips for smarter purchasing decisions.</p>
            <div className="mt-8">
              <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-3">Stay updated</p>
              <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-2">
                <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="antispam-control" />
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="flex-1 bg-transparent border-b border-foreground-300 px-1 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
                />
                <button
                  type="submit"
                  disabled={status === 'loading'}
                  className="px-5 py-2 rounded-full border border-foreground-300 text-sm font-medium text-foreground-800 hover:bg-foreground-100 transition-all cursor-pointer whitespace-nowrap disabled:opacity-50"
                >
                  {status === 'loading' ? 'Sending...' : 'Subscribe'}
                </button>
              </form>
              {status === 'success' && <p className="mt-2 text-xs text-accent-500">Thanks for subscribing!</p>}
              {status === 'error' && <p className="mt-2 text-xs text-red-500">{formError}</p>}
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Categories</p>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <a key={cat.name} href={cat.url} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Resources</p>
            <div className="flex flex-col gap-2">
              {articleLinks.map((link) => (
                link.path ? (
                  <Link key={link.name} to={link.path} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {link.name}
                  </Link>
                ) : (
                  <a key={link.name} href={link.hash} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors whitespace-nowrap">
                    {link.name}
                  </a>
                )
              ))}
            </div>
          </div>
          <div>
            <p className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4">Company</p>
            <div className="flex flex-col gap-2">
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">About Us</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Editorial Policy</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Privacy Policy</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Terms of Service</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Disclaimer</a>
              <a href="#" className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">Contact</a>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">&copy; {new Date().getFullYear()} Superbuy Spreadsheet. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">Superbuy Sheet</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-800 transition-colors">Buy It Now</a>
          </div>
        </div>
      </div>
    </footer>
  );
}